import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-lavabo",
  "use": "icon-si-glyph-lavabo-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-lavabo\" id=\"icon-si-glyph-lavabo\"><title>784</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(4.000000, 0.000000)\" fill=\"#434343\"><path d=\"M9.969,5.021 L0.031,5.021 C0.031,6.664 2.52,8.667 4.897,8.914 L4.048,14.611 C4.048,15.349 4.596,15.997 5.334,15.997 L8.633,15.997 C9.371,15.997 9.969,15.399 9.969,14.661 L9.969,5.021 L9.969,5.021 Z\" class=\"si-glyph-fill\" /><path d=\"M8.062,5.027 L8.062,1.523 C8.062,1.127 7.843,0.986 7.455,0.986 L6.365,0.986 L5.953,1.953 L5.042,1.669 L5.695,0.341 C5.769,0.164 5.947,0.045 6.143,0.045 L7.642,0.045 C8.431,0.045 8.941,0.504 8.941,1.213 L8.941,5.027 L8.062,5.027 L8.062,5.027 Z\" class=\"si-glyph-fill\" /><rect x=\"7\" y=\"3\" width=\"1.223\" height=\"0.937\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-lavabo.svg
// module id = pH6K
// module chunks = 62